// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2jo0M","consentsList":"PatientConsents_consentsList__1iC7s","consentsListEmpty":"PatientConsents_consentsListEmpty__1dZ42"};